export default __webpack_public_path__ + "static/media/ng.21d432ff.png";